module.exports = __webpack_public_path__ + "img/base_hebergements_insolite_2.308a43f5.svg";